import { IsString, IsNotEmpty, IsEmail, MinLength, MaxLength, IsInt, IsOptional, IsUUID } from 'class-validator';

export class AuthLoginDTO {

    @IsNotEmpty()
    @IsEmail()
    email: string;

    @IsNotEmpty()
    @IsString()
    @MinLength(8)
    @MaxLength(75)
    password: string;

    @IsOptional()
    @IsInt()
    otp?: number;

    @IsOptional()
    @IsUUID()
    tenant?: string;

}
